var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"clearfix",attrs:{"id":"main-content"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"admin-content","id":"location-content"},slot:"admin-content"},[_c('h3',{staticClass:"text-center"},[_vm._v("Please use the filter to find the history of your exchange rates")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95bd8bba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/ExchangeRateHistory/ExchangeRateHistory.vue
// module id = 1978
// module chunks = 1